<template>
  <div class="px-3 pt-3">
    <div class="grid mb-3 gap-y-2" :class="`grid-cols-${gridCols}`">
      <checkbox-dropdown-item v-for="(opt) in options"
                              :key="opt.id"
                              :data="opt"
                              class="py-1"
                              :value="isChecked(opt.id)"
                              @update:value="handleCheckboxToggle(opt.id)"
      />
    </div>
    <div v-if="!hideFooter" class="flex justify-center border-0 border-t border-gray-a10 border-solid py-2">
      <base-button variant="transparent-small" @click="handleMultiSelectButton">
        {{ buttonLabel }}
      </base-button>
    </div>
  </div>
</template>

<script>
import CheckboxDropdownItem from '@/components/common/CheckboxDropdownItem'
import BaseButton from '@/components/base-components/BaseButton'
import append from 'ramda/src/append'
import without from 'ramda/src/without'

export default {
  name: 'CheckboxDropdown',

  components: {
    CheckboxDropdownItem,
    BaseButton
  },

  props: {
    options: {
      type: Array,
      required: true
    },
    gridCols: {
      type: [Number, String],
      default: 1
    },
    checkedValues: {
      type: Array,
      default: () => []
    },
    isNoValueAllowed: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    buttonLabel() {
      return this.areAllValueSelected ? 'Select none' : 'Select all'
    },

    areAllValueSelected() {
      return this.options.length === this.checkedValues?.length
    },

    allCheckedValues() {
      return this.options.map(option => option.id)
    }
  },

  methods: {
    isChecked(id) {
      return this.checkedValues?.includes(id)
    },

    handleCheckboxToggle(id) {
      const newCheckedValues = this.isChecked(id) ?
        without([id], this.checkedValues) :
        append(id, this.checkedValues)
      this.emitChange(newCheckedValues)
    },

    handleMultiSelectButton() {
      const newCheckedValues = this.areAllValueSelected ? [] : this.allCheckedValues
      this.emitChange(newCheckedValues)
    },

    emitChange(newCheckedValues) {
      this.$emit('change', newCheckedValues)
    }
  }
}
</script>
